.svg{height:25rem}.svg--medium{height:35rem}.svg--large{height:40rem}.svg .hour,.svg .minutes,.svg .seconds,.svg .no-pointer{transform-origin:center}.svg .hour,.svg .minutes,.svg .seconds{cursor:pointer}
/*# sourceMappingURL=analog-clock.component-ZFWMLIBP.css.map */
